"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import React from "react";
import ReactDOM from "react-dom";
import $ from "jquery";
import * as popout from "./popout";
function formatDate(value) {
  try {
    return new Date(value).toISOString().slice(0, 10);
  } catch (e) {
    return void 0;
  }
}
function forceString(value) {
  try {
    return value.toString();
  } catch (e) {
    return null;
  }
}
export default React.createClass({
  getInitialState: function() {
    return {
      identifier: ""
    };
  },
  componentDidMount: function() {
    $(ReactDOM.findDOMNode(this.refs.input)).droppable({
      drop: (event, ui) => {
        const value = ui.helper.data("chars");
        switch (this.refs.input.getAttribute("type")) {
          case "date":
            return this.props.onDrop(event, formatDate(value));
          default:
            return this.props.onDrop(event, forceString(value));
        }
      },
      scope: "dnd-text",
      activeClass: "ocred-document__drop-target"
    });
    this.state.identifier = popout.setupDocPageLineFromPopoutListener(
      this.handlePopoutListenerUpdate
    );
  },
  handleClick(e) {
    popout.setFieldSelection(this.state.identifier);
  },
  handlePopoutListenerUpdate(value) {
    switch (this.refs.input.getAttribute("type")) {
      case "date":
        return this.props.valueLink.requestChange(formatDate(value));
      default:
        return this.props.valueLink.requestChange(forceString(value));
    }
  },
  render: function() {
    return /* @__PURE__ */ React.createElement("input", __spreadProps(__spreadValues({ ref: "input" }, this.props), { onClick: this.handleClick }));
  }
});
